export const setDefaultValues = (defaults, data) => {
  let values = { ...defaults };

  if (!data) return values;

  for (const [key, value] of Object.entries(values)) {
    values[key] = data.hasOwnProperty(key) ? data[key] : value;
  }

  return values;
};
